import { combineReducers } from "redux";

import { reduceErrorBoundaryKey } from "./errorBoundaryKey";

export default combineReducers({
  key: reduceErrorBoundaryKey
});
